import { CartesianGrid, Legend, Line, LineChart, Tooltip, XAxis, YAxis } from "recharts"

import { diagramColors, IAnalyticsPageDisplayUnit } from "@/types/IAnalytics"


export interface AnalyticsLineChartProps {
  data: any[] | undefined
  dataKeys: IAnalyticsPageDisplayUnit[]
  colors?: string[]
}

export const AnalyticsLineChart = (props: AnalyticsLineChartProps) => {
  const { data, dataKeys, colors } = props

  return (
    <LineChart width={1400} height={600} data={data}
               margin={{ top: 5, right: 20, left: 10, bottom: 5 }}>
      <XAxis dataKey="period"/>
      <YAxis domain={["auto", "auto"]} />
      <Tooltip/>
      <Legend wrapperStyle={{ width: "100%" }} />
      <CartesianGrid stroke="#f5f5f5"/>
      {
        dataKeys.map((data, index) => (
          <Line
            dot={false}
            key={index}
            type="monotone"
            dataKey={data.value}
            name={data.bigLabel}
            stroke={(colors ?? diagramColors)[index]}/>
        ))
      }
    </LineChart>
  )
}
